<div class="caa-disclosure" *transloco="let t">
	<op-back-link class="op-mt-20" id="accessibilityBck">{{ t('ACCESSIBILITY.back') }}</op-back-link>
	<op-masthead [title]="t('ESIGN_DISCLOSURE.caaDisclosure')"></op-masthead>
	<op-content-container class="content">
		<div *ngIf="issuingOrganization === 'METABANK'">{{ t('ESIGN_DISCLOSURE.caaDisclosureContentPathward') }}</div>
		<div *ngIf="issuingOrganization === 'OPORTUN'">{{ t('ESIGN_DISCLOSURE.caaDisclosureContentOportun') }}</div>
	</op-content-container>
</div>
